var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLicenceTypeIntegrationCost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.72667 9.00634L10.28 11.6597M10.2733 4.33967L5.72667 6.99301M14 3.33301C14 4.43758 13.1046 5.33301 12 5.33301C10.8954 5.33301 10 4.43758 10 3.33301C10 2.22844 10.8954 1.33301 12 1.33301C13.1046 1.33301 14 2.22844 14 3.33301ZM6 7.99967C6 9.10424 5.10457 9.99967 4 9.99967C2.89543 9.99967 2 9.10424 2 7.99967C2 6.89511 2.89543 5.99967 4 5.99967C5.10457 5.99967 6 6.89511 6 7.99967ZM14 12.6663C14 13.7709 13.1046 14.6663 12 14.6663C10.8954 14.6663 10 13.7709 10 12.6663C10 11.5618 10.8954 10.6663 12 10.6663C13.1046 10.6663 14 11.5618 14 12.6663Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenceTypeIntegrationCost);
export default __webpack_public_path__ + "static/media/licence_type_integration_cost.ee5b06e75c8d7f18097c86be80d15bde.svg";
export { ForwardRef as ReactComponent };